import { Account } from '@/domain/usecases'
import { dependentRequestService } from '@/data/services/dependent/dependent-service'

/**
 * Loads dependent configuration settings for company manager
 * Fetches company dependent request settings
 */
export async function loadCompanyManagerDependentConfiguration(account: Account.Model) {
  const settings = await dependentRequestService.fetchSettings(account.company.uniqueId)

  return {
    data: {
      ...settings,
      plans: settings?.plans || [],
      upgradePlans: settings?.upgradePlans || []
    },
    accountProfile: account
  }
}
